import { callDecimal } from "../utils.ts";
import {
  CompositeAsset,
  RecommendationState,
} from "../common-types/manageAssets.ts";

export function getRecommendations() {
  return callDecimal<CompositeAsset<"recommendation">[]>(
    "/api/v1/instructors/recommendations"
  );
}

export function updateRecommendation(
  id: number | string,
  data: { state: RecommendationState }
) {
  return callDecimal(`/api/v1/instructors/recommendations/${id}`, {
    method: "PATCH",
    body: JSON.stringify({
      data,
    }),
  });
}

export function acceptRecommendationToken(token: string) {
  return callDecimal<CompositeAsset>(
    `/api/v1/instructors/access_tokens/${token}/accept`,
    {
      method: "POST",
    }
  );
}
